{
  "actions": {
    "title": "New products",
    "devices": "New devices",
    "applications": "New applications"
  },
  "services": {
    "title": "Service Activation",
    "activeDirectory": "Active Directory",
    "pkiConnector": "PKI Connector",
    "smtpServer": "SMTP Server",
    "unauthorized": "No service activation information available"
  },
  "sector": {
    "title": "My sectors",
    "devices": "Devices",
    "applications": "Applications"
  },
  "certificates": {
    "valid": "Valid certificates",
    "certificate": "certificates",
    "device": "S4 certificates",
    "manager": "S4-Manager certificates",
    "tools": "S4-Tools certificates",
    "view": "S4-View Certificates",
    "legend": {
      "valid": "valid",
      "expireSoon": "validity < 1 month",
      "expired": "expired"
    },
    "noData": "No data",
    "title": "Certificate state",
    "expired": "Expired",
    "lessThanOneMonth": "Less than 1 month",
    "lessThanThreeMonths": "Less than 3 months",
    "lessThanSixMonths": "Less than 6 months",
    "moreThanSixMonths": "More than 6 months"
  },
  "firmwares": {
    "noData": "No data",
    "others": "Others",
    "title": "Firmware version distribution",
    "unknown": "Unknown"
  },
  "deviceStates": {
    "title": "Device state",
    "states": {
      "activated": "Activated",
      "disabled": "Disabled",
      "preprovisioned": "Pre-provisioned",
      "registered": "Registered",
      "locked": "Locked"
    }
  },
  "connectivity": {
    "title": "Connectivity state",
    "states": {
      "lessThan": "Less than {duration}",
      "moreThan": "More than {duration}",
      "unknown": "No polling yet"
    },
    "noData": "No data"
  }
}
